// ALl period

export enum IPeriod {
	'week',
	'twoWeeks',
	'month',
}

// Options to filter by period *used on select component*

export interface IPeriodOption {
	label: string;
	value: any;
}
